import type { TrackedSignalMatch } from '@tennis-scanner/shared';

// Shared formatters for opportunity / tracked-pick cards. Extracted so we
// don't duplicate the same labels in two files (and so each card stays
// under the 300-line budget).

export function selectionLabel(selection: string, match: TrackedSignalMatch | null): string {
  if (!match) return selection.toUpperCase();
  if (selection === 'p1' && match.p1Name) return match.p1Name;
  if (selection === 'p2' && match.p2Name) return match.p2Name;
  return selection.toUpperCase();
}

export function marketLabel(market: string): string {
  if (market === 'h2h') return 'Ganador';
  if (market === 'handicap') return 'Hándicap';
  if (market === 'totals') return 'Total games';
  if (market === 'set_winner') return 'Ganador del set';
  return market.toUpperCase();
}

export function shortLevel(raw: string | null): string | null {
  if (!raw) return null;
  const l = raw.toLowerCase();
  if (l.startsWith('atp')) return 'ATP';
  if (l.startsWith('wta')) return 'WTA';
  if (l.startsWith('challenger')) return 'CH';
  if (l.startsWith('itf men')) return 'ITF M';
  if (l.startsWith('itf women')) return 'ITF W';
  return raw.slice(0, 6).toUpperCase();
}

export function levelChipClass(raw: string | null): string {
  const l = (raw ?? '').toLowerCase();
  if (l.startsWith('atp')) return 'border-info/40 text-info bg-info/10';
  if (l.startsWith('wta')) return 'border-ai-verdict/40 text-ai-verdict bg-ai-verdict/10';
  if (l.startsWith('challenger')) return 'border-warning/40 text-warning bg-warning/10';
  return 'border-muted-foreground/40 text-muted-foreground bg-muted';
}

// Spanish-friendly long name for tooltips on the level chip.
export function levelFullName(raw: string | null): string {
  if (!raw) return '—';
  const l = raw.toLowerCase();
  if (l.startsWith('atp')) return `ATP — circuito masculino mayor (${raw})`;
  if (l.startsWith('wta')) return `WTA — circuito femenino mayor (${raw})`;
  if (l.startsWith('challenger')) return `Challenger — segunda división ATP (${raw})`;
  if (l.startsWith('itf men')) return `ITF Men — circuito desarrollo masculino (${raw})`;
  if (l.startsWith('itf women')) return `ITF Women — circuito desarrollo femenino (${raw})`;
  return raw;
}

export function formatStartsAt(iso: string | null): string {
  if (!iso) return '—';
  const date = new Date(iso);
  return date.toLocaleString('es-AR', {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
}
